<script setup lang="ts">
import LockIcon from '@/components/icons/LockIcon.vue'

type FormGroupLayoutType = 'cols' | 'row'

interface Props {
  label: string
  labelFor: string
  layout?: FormGroupLayoutType
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  layout: 'row',
})
</script>

<template>
  <div :class="['form-group', `form-group--${layout}`, disabled && `form-group--disabled`]">
    <label class="form-group-label" :for="labelFor">
      {{ label }}
      <LockIcon v-if="disabled" color="red" />
    </label>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.form-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  &--cols {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .form-group-label {
      min-width: 75px;

      @include media('md-and-up') {
        min-width: 100px;
      }
    }
  }

  :deep(.v-field) {
    border-radius: 10px;
    border: 1px solid #cdcdcd;
  }

  &--disabled {
    color: var(--gray-light-a7);

    .form-group-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}

.form-group-label {
  font-size: 18px;
  font-weight: 700;

  @include media('md-and-up') {
    font-size: 20px;
  }
}
</style>
